import request from "superagent";
import { getAuthHeader } from "../../utils/superagent";

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'facilityId' implicitly has an 'any' type.
export const setMetropolitanStatisticalArea = async (facilityId, metropolitanStatisticalArea) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .put(`${global.api}/facilities/${facilityId}/address`)
      .set(await getAuthHeader())
      .send({ address: { metropolitanStatisticalArea } })
  );
};

// @ts-expect-error TODO(typecheck-unify): TS7006 Parameter 'agentId' implicitly has an 'any' type.
export const setMetropolitanStatisticalAreaHCP = async (agentId, metropolitanStatisticalArea) => {
  return (
    request
      // @ts-expect-error TODO(typecheck-unify): TS7017 Element implicitly has an 'any' type because type 'typeof globalThis' has no index signature.
      .put(`${global.api}/agentprofile/${agentId}/address`)
      .set(await getAuthHeader())
      .send({ address: { metropolitanStatisticalArea } })
  );
};
